import { render, staticRenderFns } from "./StoreDescription.vue?vue&type=template&id=6b3ee375&scoped=true"
import script from "./StoreDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreDescription.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StoreDescription.vue?vue&type=style&index=0&id=6b3ee375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3ee375",
  null
  
)

export default component.exports